import { boundsAround, hasUsableCoordinates } from "./SmartGuideMapViewport";
import type { DestinationRoutePoiMarker, LngLatBoundsLike } from "./SmartGuidePermanentMapTypes";

export const tourPoiCameraDurationMs = 200;
export const tourPoiCameraMaxZoom = 19;
export type TourPoiCameraLayout = { width: number; height: number; topOccupied: number; bottomOccupied: number };

export function getTourPoiCameraBounds(markers: readonly DestinationRoutePoiMarker[], selectedPoiId: string): LngLatBoundsLike | undefined {
    const ordered = [...markers].sort((a, b) => a.order - b.order);
    const index = ordered.findIndex(marker => marker.id === selectedPoiId);
    const selected = ordered[index];
    if (!hasUsableCoordinates(selected)) {
        return undefined;
    }
    const neighbors = ordered.slice(Math.max(0, index - 1), index + 2).filter(hasUsableCoordinates);
    if (new Set(neighbors.map(marker => `${marker.latitude}:${marker.longitude}`)).size < 2) {
        return boundsAround(selected, 100);
    }
    return [
        [Math.min(...neighbors.map(marker => marker.longitude)), Math.min(...neighbors.map(marker => marker.latitude))],
        [Math.max(...neighbors.map(marker => marker.longitude)), Math.max(...neighbors.map(marker => marker.latitude))]
    ];
}

export function getTourPoiCameraPadding(layout: TourPoiCameraLayout): { top: number; right: number; bottom: number; left: number } {
    const width = nonnegative(layout.width);
    const height = nonnegative(layout.height);
    if (!width || !height) {
        return { top: 0, right: 0, bottom: 0, left: 0 };
    }
    const top = 70 + nonnegative(layout.topOccupied);
    const bottom = 70 + nonnegative(layout.bottomOccupied);
    const scale = Math.min(1, Math.max(0, height - 10) / (top + bottom));
    const side = Math.min(70, Math.max(0, width - 10) / 2);
    return { top: top * scale, right: side, bottom: bottom * scale, left: side };
}

function nonnegative(value: number): number {
    return Number.isFinite(value) ? Math.max(0, value) : 0;
}
